import {Injectable} from '@angular/core';
import {HttpClientService} from './httpClient.service';
import {TipoServico} from '../model/tiposervicos.model';
import {Servico} from '../model/servico.model';
import {map} from 'rxjs/operators';
import {ConfigurationService} from './configuration.service';

@Injectable()
export class ServicoService {
    apiUrl: string;
    private httpOptions : any;

    constructor(
        private http: HttpClientService,
        private configService: ConfigurationService
    ) {
        this.onConfigLoad = this.onConfigLoad.bind( this );
        configService.loadConfigurations().subscribe( this.onConfigLoad );
    }

    getTipoServicos(agenciaId) {
        const cookie = JSON.parse(localStorage.getItem('cookie'));
        this.getAuthToken();
        return this.http.get<TipoServico[]>(`${this.apiUrl}/back/integracao/servicos/tipoServicos?cookie=` + cookie + '&agenciaId=' + agenciaId, this.httpOptions).pipe(map(response => response));
    }

    getServicos(agenciaId, tipoServicoId, empresa: boolean) {
        var cookie = JSON.parse(localStorage.getItem('cookie'));
        var isEmpresa = "0";
        if (empresa) {
          isEmpresa = "1";
        }
        this.getAuthToken();
        return this.http.get<Servico[]>(`${this.apiUrl}/back/integracao/servicos/v2?cookie=` + cookie + '&agenciaId=' + agenciaId + '&tipoServicoId=' + tipoServicoId + '&empresa=' + isEmpresa, this.httpOptions).pipe(map(response => response));
    }

    private onConfigLoad( config ) {
        this.apiUrl = config.apiUrl;
    }

    private getAuthToken(){
        this.httpOptions = { "Authorization": `Bearer ${localStorage.getItem('authToken').toString().replace('"', '')}` };
    }
}
